export enum ToolEnum {
    None,
    Surface,
    Azimuth,
    Length,
    Delete,
    Exclusion,
    Panneau,
    EnedisLine,
    PrivateTrenchEnrobee,
    PrivateTrenchNaturel,
    PrivateTrenchToiture,
    MeterBt,
    TransformerHt,
    GenericDistance
}
